export const environment = {
    production: true,
    clientUrl: "https://outlook-addin.theadaptway.com",
    lumiaUrl: "https://lumia.theadaptway.com",
    apiUrl: "https://api.theadaptway.com",
    AdaptEnvironmentName: "Production",
    SentryDsn: "https://50bf0bdf81be4c4bae2a9d610002da9e@o96030.ingest.sentry.io/6055662",
};
